import React from 'react'
import { View } from 'react-native'
import { startCase } from 'lodash'
import { useTheme } from '@ui-kitten/components'
import { useIsDarkMode } from '@src/config/theme'
import { StyleService, useStyleSheet } from '@style/service'
import { ChatbotConversationTag } from '@src/types'
import { Text } from '@components/base'

export const tagColors = {
  [ChatbotConversationTag.Glucose]: {
    background: 'theme.success.lightest',
    text: 'theme.success.darkest',
    darkText: 'theme.success.light_',
  },
  [ChatbotConversationTag.Meals]: {
    background: 'theme.warning.lightest',
    text: 'theme.warning.darkest',
    darkText: 'theme.warning.light_',
  },
  [ChatbotConversationTag.Activity]: {
    background: 'theme.info.lightest',
    text: 'theme.info.darkest',
    darkText: 'theme.info.light_',
  },
  [ChatbotConversationTag.Energy]: {
    background: 'theme.warning.lightest',
    text: 'theme.warning.darkest',
    darkText: 'theme.warning.light_',
  },
  [ChatbotConversationTag.Sleep]: {
    background: 'theme.purple.lightest',
    text: 'theme.purple.darkest',
    darkText: 'theme.purple.light_',
  },
  [ChatbotConversationTag.Stress]: {
    background: 'theme.error.lightest',
    text: 'theme.error.darkest',
    darkText: 'theme.error.light_',
  },
} as const

export const defaultTagColors = {
  background: 'theme.surface.base2',
  text: 'theme.text.primary',
  darkText: 'theme.text.primary',
} as const

export const ConversationTag = ({ tag }: { tag: ChatbotConversationTag }) => {
  const styles = useStyleSheet(themedStyle)
  const theme = useTheme()
  const isDarkMode = useIsDarkMode()

  const colorsMap: Partial<
    Record<ChatbotConversationTag, typeof tagColors[keyof typeof tagColors]>
  > = tagColors
  const colors = colorsMap[tag] ?? defaultTagColors
  const bgColor = theme[colors.background]
  const textColor = theme[isDarkMode ? colors.darkText : colors.text]

  return (
    <View style={[styles.tag, { backgroundColor: isDarkMode ? `${String(bgColor)}1A` : bgColor }]}>
      <Text type="tiny" bold style={{ color: textColor }}>
        {startCase(tag)}
      </Text>
    </View>
  )
}

const themedStyle = StyleService.create({
  tag: {
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
})
